// Default config constants — extracted verbatim from partners-portal.jsx. Pure data.

export const DEFAULT_AGREEMENT_TYPES = [
  'One-time MCA Referral Fee',
  'Basic MCA Referral Fee',
  'Table MCA Referral Fee',
  'Revenue Pool MCA',
];

// Default commission terms per agreement type — overridable per partner
export const DEFAULT_COMMISSION_TERMS = {
  // Type 1: single custom % negotiated per referral (no active/non-active split)
  'One-time MCA Referral Fee': {
    type: 'fixed',
    percentage: 10,
    paymentTermsDays: 10,
  },
  // Type 2: two flat rates — one for client introductions, one for investor introductions
  'Basic MCA Referral Fee': {
    type: 'basic',
    clientPercentage: 10,
    investorPercentage: 20,
    paymentTermsDays: 10,
  },
  // Type 3: 4×2 table — deal size tier × involvement level
  'Table MCA Referral Fee': {
    type: 'table',
    brackets: [
      { upTo: 5000000,  nonActive: 20, active: 30 },
      { upTo: 10000000, nonActive: 13, active: 24 },
      { upTo: 15000000, nonActive: 12, active: 20 },
      { upTo: null,     nonActive: 11, active: 15 },
    ],
    paymentTermsDays: 10,
  },
  // Type 4: pool — each party contributes their entitlement; split agreed before close
  'Revenue Pool MCA': {
    type: 'pool',
    poolSplitPercentage: 50,
    paymentTermsDays: 10,
  },
};

export const DEFAULT_BUSINESS_RULES = {
  autoRejectDays: 7,
  introWindowDays: 60,
  tailMonths: 18,
};

// Default commission rate EvE charges the CLIENT per deal — separate from partner split
export const DEFAULT_COMMISSION_DEFAULTS = {
  'One-time MCA Referral Fee': { percentage: 5,  description: 'Single deal finder fee' },
  'Basic MCA Referral Fee':    { percentage: 10, description: 'Referral commission' },
  'Table MCA Referral Fee':    { percentage: 10, description: 'Tiered referral commission' },
  'Revenue Pool MCA':          { percentage: 15, description: 'Revenue pool participation' },
};
